import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 24px 0 0 0;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const GroupLabel = styled.span`
  color: #6A7282;
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  margin-bottom: 8px;
  padding: 0 32px;
`;

export const Divider = styled.hr`
  border: none;
  height: 12px;
  margin: 0;
`;

export const VsImage = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid rgba(100, 116, 139, 0.40);
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    object-fit: contain;
  }
`;

export const Group = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  gap: 24px;

  ${({ theme }) => theme.max("md")`
    flex-direction: column;
  `}
`;

export const Col = styled.div`
  flex: 1;
  text-align: center;
  align-self: normal;

  &:first-child {
    margin-right: 8px;
  }

  &:last-child {
    margin-left: 8px;
  }
`;

export const VsText = styled.span`
  width: 30px;
  height: 30px;
  line-height: 30px;
  color: #64748B;
  text-align: center;
  font-family: Inter;
  font-size: 11.357px;
  border-radius: 50%;
  border: 1px solid rgba(100, 116, 139, 0.40);
`;
